"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../utils");

/**
 * Heading component is a simple wrapper around standard HTML headings.
 */
var Heading = function Heading(_ref) {
  var children = _ref.children,
      className = _ref.className,
      level = _ref.level,
      display = _ref.display,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? "h" + level : _ref$tag,
      restProps = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["children", "className", "level", "display", "tag"]);
  return _react.default.createElement(Tag, (0, _extends2.default)({
    className: _utils.classNames.use({
      display: display
    }, className)
  }, restProps), children);
};

Heading.propTypes = {
  /**
   * An integer between 1 and 6 (including) to calculate the tag.
   * NOTE: If `tag` prop is passed, `level` will be ignored.
   */
  level: _propTypes.default.number.isRequired,

  /**
   * A toggle for display mode.
   */
  display: _propTypes.default.bool
};
Heading.defaultProps = {
  display: false
};
var _default = Heading;
exports.default = _default;